import { HttpMethodEnum, Route } from "../../../../utils/route";
import { zProfile } from "@dobrh-monorepo/core";

const responseType = zProfile;

export default {
  method: HttpMethodEnum.GET,
  responseZodSchema: responseType,
} satisfies Route;
